export const type = (obj) => {
  return Object.prototype.toString.call(obj).slice(8, -1).toLowerCase();
};

export const isEmpty = (obj) => {
  let t = type(obj);
  if (t === 'null' || t === 'undefined' || (t === 'string' && !obj)) {
    return true;
  } else if (t === 'array') {
    return !obj.length;
  } else if (t === 'object') {
    let rs;
    for (let k in obj) {
      rs = true;
    }
    return !rs;
  } 
  return false;
};

export const DateUtils = {
  //需要重构
  buildDate: function (str, sep) {
    sep = sep || '-';
    if (typeof (str) == 'number') {
      return new Date(str);
    } else if (str instanceof Date) {
      return str;
    }
    if (!str) {
      return null;
    }
    if (str.indexOf('+') >= 0) {
      str = str.replace('+0800 ', '');
    }
    str = str.indexOf('T') > 0 ? str : str.replace(/-/g, '/');
    return new Date(str);
  },
  /**
   * yyyy-MM-dd HH:mm
   * @param {Date| number | str} dataStr
   * @param {Object} pattern
   */
  format: function (dataStr, pattern) {
    if (!dataStr) return '-';
    pattern = pattern || 'yyyy-MM-dd';
    var date = DateUtils.buildDate(dataStr);
    var hour = date.getHours();
    var o = {
      'M+': date.getMonth() + 1, //month
      'd+': date.getDate(), //day
      'H+': hour, //hour
      'h+': (hour > 12 ? hour - 12 : hour), //hour
      'm+': date.getMinutes(), //minute
      's+': date.getSeconds(), //second
      'q+': Math.floor((date.getMonth() + 3) / 3), //quarter
      'S': date.getMilliseconds() //millisecond
    };
    if (/(y+)/.test(pattern)) {
      pattern = pattern.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
    }
    for (var k in o)
      if (new RegExp('(' + k + ')').test(pattern)) {
        pattern = pattern.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
      }
    return pattern;
  },
  getChineseDate: function (tar, res) {

    if (!res) {
      res = new Date();
    }
    if (typeof (tar) == 'string') {
      tar = this.buildDate(tar);
    }
    if (!tar || !tar.getTime()) {
      return '';
    }
    var resTime = res.getTime();
    var tarTime = tar.getTime();
    var between = (resTime - tarTime) / 1000;
    return this.between(between) + '前';
  },
  between: function (bet) {
    bet = Math.abs(parseInt(bet));
    bet = bet == 0 ? 1 : bet;
    if (bet < 60) {
      return bet + '秒';
    }
    if (bet < 3600) {
      return parseInt(bet / 60) + '分钟';
    }
    if (bet < 3600 * 24) {
      return parseInt(bet / 3600) + '小时';
    }
    if (bet < 3600 * 24 * 30) {
      return parseInt(bet / (3600 * 24)) + '天';
    }
    if (bet < 3600 * 24 * 30 * 12) {
      return parseInt(bet / (3600 * 24 * 30)) + '月';
    }
    return parseInt(bet / (3600 * 24 * 30 * 12)) + '年';
  },
  /**
   * 剩余多少时间
   * 1天20小时15分20秒
   * @param {Object} second
   */
  liveTime: function (second) {

  },
  /**时间差*/
  differenceTime: function (second, str, flag) {
    var m = parseInt(second / 60);
    var h = parseInt(m / 60);
    var s = second % 60;
    m = m < 10 ? '0' + m : m;
    s = s < 10 ? '0' + s : s;
    if (!/h+/.test(str)) {
      var o = {
        'm+': m,
        's+': s
      };
      for (var k in o)
        if (new RegExp('(' + k + ')').test(str)) {
          str = str.replace(RegExp.$1, o[k]);
        }
    } else {
      h = h < 10 ? '0' + h : h;
      m = m % 60;
      m = m < 10 ? '0' + m : m;
      var o = {
        'h+': h,
        'm+': m,
        's+': s
      };
      for (var k in o)
        if (new RegExp('(' + k + ')').test(str)) {
          str = str.replace(RegExp.$1, o[k]);
        }
    }
    if (h == 0 && flag === true) {
      return str.substr(3, 7);
    }
    return str;
  },
  getUTCDate: function (date) {
    // date = this.buildDate(date);
    // // date = new Date(date)
    // console.log(date)
    // return date

    var dateArr = date.split(' ');
    dates = dateArr[0].split('-');

    if (dateArr[1]) {
      var times = dateArr[1].split(':');
      return new Date(
        dates[0], dates[1] - 1, dates[2], times[0], times[1], times[2]
      );

    }

    return new Date(
      dates[0], dates[1] - 1, dates[2]
    );
  },
  differ: function (start, end, unit = (24 * 60 * 60 * 1000)) {
    var diff = Math.abs(start - end);
    return Math.floor(diff / unit);
  },
};

function roundNumber(number, decimals) {
  decimals = decimals * 1;
  var d = Number('1e' + decimals);
  var num = Math.round(number * d) / d;
  var numStr = '' + num;
  if (numStr.indexOf('.') === -1) {
    var suffix = '.';
    for (var i = 0; i < decimals; i++) {
      suffix += '0';
    }
    return numStr + suffix;
  } else {
    var dotstr = numStr.substring(numStr.indexOf('.') + 1, numStr.length);
    var len = dotstr.length;
    if (len < decimals) {
      var count = decimals - len;
      for (var i = 0; i < count; i++) {
        numStr += '0';
      }
    }
    return numStr;
  }

}

export const numUtils = {

  formatNum: function (num, type) {

    if (!num || typeof (num) == 'undefined') return 0;
    if (!type) return num;
    num = Number(num);

    let _type = type.split('.');

    if (/^\./g.test(type)) {
      _type[0] = '.';
    }


    if (_type[1] && /%/g.test(_type[1])) {
      let _t_ = _type.pop();
      _type = _type.concat(_t_.split(''));
    }

    switch (_type[0]) {

      case ',':
        if (_type[1]) {
          num = parseFloat(num).toFixed(_type[1] || 2);
        }

        return num.toString().replace(/(\d)(?=(\d{3})+?($|\.))/ig, '$1,');

      case '.':
        if (_type[2] == '%') { // .3%

          var wei = _type[1] || 2;
          return roundNumber(num * 100, wei) + _type[2];
        }
        var wei = _type[1] || 2;
        return roundNumber(num, wei);
      case '%':
        return (num * 100) + _type[2];
      case 'string':
      default :
        return num.toString();

    }
    return num;

  },

  commaNum: function (number) {
    number = (number || 0) + '';
    var nums = number.split('.');
    nums[0] = nums[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return nums.join('.');
  },
  spaceNum: function (number) {
    number = (number || 0) + '';
    var nums = number.split('.');
    nums[0] = nums[0].replace(/\B(?=(\d{4})+(?!\d))/g, ' ');
    return nums.join('.');

  },
};

/**
 * 从$route中取出的query进行数字的修复
 * @param query
 * @return {*}
 */
export const queryNumFix = query => {
  query = Object.assign({}, query);
  Object.keys(query).forEach(key => {
    let value = query[key];
    if (value !== '' && !isNaN(value)) query[key] = Number(value);
  });
  return query;
};

export const deepMerge = (obj1, obj2) => {
  var key;
  for(key in obj2) {
    obj1[key] = obj1[key] && obj1[key].toString() === "[object Object]" ?
    deepMerge(obj1[key], obj2[key]) : obj1[key] = obj2[key];
  }
  return obj1;
}

export const openDownloadDialog = (url, saveName) => {
  if(typeof url == 'object' && url instanceof Blob) {
    url = URL.createObjectURL(url); // 创建blob地址
  }
  let aLink = document.createElement('a');
  aLink.href = url;
  aLink.download = saveName || ''; // HTML5新增的属性，指定保存文件名，可以不要后缀，注意，file:///模式下不会生效
  let event;
  if(window.MouseEvent) {
    event = new MouseEvent('click');
  } else {
    event = document.createEvent('MouseEvents');
    event.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
  }
  aLink.dispatchEvent(event);
};

export const getAssetImage = (url) => {
  return 'http://t1.market.xiaomi.com/thumbnail/jpeg/w1000/' + url;
};

export const getAssetVideo = (url) => {
  return 'http://t1.market.xiaomi.com/download/' + url;
};


export const uuid = () => {
  const temp_url = URL.createObjectURL(new Blob());
  let uuid = temp_url.toString(); // blob:https://xxx.com/b250d159-e1b6-4a87-9002-885d90033be3
  URL.revokeObjectURL(temp_url);
  return uuid.substr(uuid.lastIndexOf("/") + 1);
};

export const qs = (url) => {
  if(!url) return {};
  const qsStr = url.split('?')[1];
  if (!qsStr) return {};
  const arr = qsStr.split('&');
  const obj = {};
  arr.forEach((item) => {
    const subArr = item.split('=');
    let key = subArr[0];
    let value = subArr[1];
    obj[key] = decodeURIComponent(value);
  });
  return obj;
};